import { useFormStore } from '@ariakit/react'
import { useMemo } from 'react'
import { z } from 'zod'

import { useTranslation } from '../../../../../../_providers/TranslationProvider.client'
import { reportClientError } from '../../../../../chrome/scripts/DataDogRumScript'
import { useZodFormValidate } from '../../../../../form/useZodFormValidate'
import { requiredString } from '../../../../../form/zodSchemas'
import { useWaitlistModal } from '../WaitlistModal'

export function useWaitlistForm() {
  const { waitlist: waitlistCopy } = useTranslation()
  const { variantSku, variantShopifyId, sendWaitlistRequest, setErrorMessage, setSuccessMessage } =
    useWaitlistModal()

  const form = useFormStore({
    defaultValues: {
      emailAddress: '',
    },
  })

  const validationSchema = useMemo(
    () =>
      z.object({
        emailAddress: requiredString(waitlistCopy.modal.form.email.requiredMessage).email(
          waitlistCopy.modal.form.email.validEmailMessage
        ),
      }),
    [waitlistCopy.modal.form.email]
  )

  useZodFormValidate(form, validationSchema)

  form.useSubmit(async state => {
    if (!variantShopifyId) {
      reportClientError({
        error: new Error(`Shopify variant gid missing.`),
        context: {
          scope: 'WaitlistModal onSubmit',
        },
      })
      return setErrorMessage(waitlistCopy.modal.errorMessage.unexpectedError)
    }

    const waitlistRequestResult = await sendWaitlistRequest({
      email: state.values.emailAddress,
      variantShopifyId,
      variantSku,
    })

    switch (waitlistRequestResult) {
      case 'email-already-registered':
        return setErrorMessage(waitlistCopy.modal.errorMessage.emailAlreadyRegistered)
      case 'unexpected-error':
        return setErrorMessage(waitlistCopy.modal.errorMessage.unexpectedError)
      case 'success':
        return setSuccessMessage(waitlistCopy.modal.successMessage)
    }
  })

  return form
}
